// network-status.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, of } from 'rxjs';
import { mapTo } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NetworkStatusService {
    private online$ = new BehaviorSubject<boolean>(navigator.onLine);

    constructor() {
        const onlineEvent$ = fromEvent(window, 'online').pipe(mapTo(true));
        const offlineEvent$ = fromEvent(window, 'offline').pipe(mapTo(false));

        merge(onlineEvent$, offlineEvent$, of(navigator.onLine)).subscribe(status => {
            console.log(`Network status changed: ${status ? 'online' : 'offline'}`);
            this.online$.next(status);
        });
    }

    isOnline() {
        return this.online$.asObservable();
    }

    getCurrentStatus(): boolean {
        return this.online$.value;
    }
}
